import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import i18n from './i18n';
import plugin from './utils/plugin.js';
import PortalVue from 'portal-vue';
import { sync } from 'vuex-router-sync';
import VueCompositionAPI from '@vue/composition-api';
import { Fragment } from 'vue-fragment';
import tokenStore from '@/utils/TokenManager/tokenStore';
import { ad } from '@/helpers/ad/ad';
import Meta from 'vue-meta';

// 결제 및 인증 모듈 콜백을 위한 giftishow.com의 모든 하위 도메인 크로스 출처 허용
if (/\.giftishow\.com$/.test(document.domain)) document.domain = 'giftishow.com';

import './browserChecker';

import '@/assets/css/bzm.import.css';

Vue.use(VueCompositionAPI);

/* Global Components */
Vue.component('Fragment', Fragment);
Vue.component('HeaderTitle', () => import('@/components/common/HeaderTitle'));

Vue.use(PortalVue);

Vue.config.productionTip = false;

Vue.config.devtools = process.env.NODE_ENV !== 'production';

Vue.use(plugin);

Vue.use(Meta, {
	refreshOnceOnNavigation: true,
	debounceWait: 5,
});

sync(store, router);

tokenStore.init();

if (window.Kakao) {
	window.Kakao.init('2525dafefca4936bc50c155014fddbc9');
}

/** tera script */
ad();

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app');
